import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-spectrum-uxp"
    }}>{`About Spectrum UXP`}</h1>
    <p>{`Spectrum UXP is designed to feel familiar to anyone who has used the HTML5 Web Components feature. This allows UXP to expose a consistent yet custom user interface without requiring a specific framework (such as React or Vue) while still encapsulating the implementation details. `}</p>
    <p>{`The version of Spectrum UXP shipping with UXP 4.1 is influenced by, but not wholly compatible with, the `}<a parentName="p" {...{
        "href": "https://opensource.adobe.com/spectrum-web-components/"
      }}>{`Spectrum Web Components`}</a>{` API and the `}<a parentName="p" {...{
        "href": "https://spectrum.adobe.com/"
      }}>{`Spectrum`}</a>{` Design System. These incongruities will be resolved in future updates.`}</p>
    <p>{`In order to get started, you can just start using the Spectrum UXP controls as you would any other HTML tag. You don't need to include any special libraries – they are immediately available to the global context. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-button>Get started!</sp-button>
`}</code></pre>
    <p>{`It's that easy! `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      